// SalesNavSourceForm — US-127 (URL field for Sales Navigator).

import { useT } from '@barel/i18n';
import { FieldAssembly, Input } from '@barel/ui';

import { isValidCampaignSearchUrl } from '../lib/sourceUrl';

export interface SalesNavSourceFormProps {
  value: string;
  onChange: (next: string) => void;
}

export function SalesNavSourceForm({ value, onChange }: SalesNavSourceFormProps) {
  const t = useT('campaigns');
  const label = t('source.salesnav') as string;
  const invalid = value.trim().length > 0 && !isValidCampaignSearchUrl(value, 'salesnav');
  return (
    <FieldAssembly
      label={t('create.sectionSource.urlLabel', { label })}
      hint={t('create.sectionSource.urlHelp')}
      error={invalid ? t('create.sectionSource.invalidSalesNavUrl') : undefined}
    >
      <Input
        type="url"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('create.sectionSource.urlPlaceholderSn') as string}
        data-testid="campaign-source-url"
      />
    </FieldAssembly>
  );
}
